<template>
  <td>
    <div>{{ formatSchedule(appointmentData.schedule) }}</div>
  </td>
  <td>
    <div>{{ appointmentData.customer_name }}</div>
  </td>
  <td>
    <div>{{ appointmentData.pet_name }}</div>
  </td>
  <td>
    <div>{{ appointmentData.appointment_status }}</div>
  </td>
  <td>
    <div>{{ appointmentData.status_date }}</div>
  </td>
  <td>
    <div v-if="appointmentData.appointment_status_key == 'TK_Confirmed' && !schedulePassed1Hour(appointmentData.schedule)">
      <a :href="generateAppointmentLink(appointmentData.vet_pin)" class="pointer">
        {{ $t('AppointmentData.Link') }}
      </a>
    </div>
    <div v-else>
      {{ $t('AppointmentData.LinkNotAvailable') }}
    </div>
  </td>
  <td>
    <div class="is-flex is-justify-content-start" style="gap: 1em;">
      <button type="button" class="button is-warning is-small"
        @click="iniAppointmentData(appointmentData)">{{ $t('General.Details') }}</button>
    </div>
  </td>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapActions, mapGetters } from 'vuex';

export default defineComponent({
  name: 'VetRecordTableRow',
  props: {
    appointmentData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      appointmentLink: process.env.BASE_URL + "appointment/"
    }
  },
  computed: {
    ...mapGetters([
      'getEditedAppointmentData',
      'getShowingAppointmentData',
      'getAccessType'
    ])
  },
  methods: {
    ...mapActions([
      'iniEditedAppointment',
      'resetAppointmentFiles',
      'iniEditedAppointmentFiles',
      'toggleAppointmentDetailing',
      'toggleShowingAppointmentData'
    ]),

    async iniAppointmentData(showAppointmentData: any) {
      await this.iniEditedAppointment(showAppointmentData.appointment_id);
      await this.resetAppointmentFiles();

      var filesStatus = 'TK_Active';
      if(this.getAccessType == 'manager')
      {
        filesStatus = 'All';
      }
      await this.iniEditedAppointmentFiles({appointmentId: showAppointmentData.appointment_id,
                                            language: this.$i18n.locale,
                                            status: filesStatus});

      this.toggleAppointmentDetailing(false);
      this.toggleShowingAppointmentData(false);
    },

    formatSchedule(schedule: string): string {
      const parts = schedule.split(' ');
      const timeParts = parts[1].split(':');
      return parts[0] + ' ' + timeParts[0] + ':' + timeParts[1];
    },

    schedulePassed1Hour(schedule: string): boolean {
      const scheduleDate = new Date(schedule);
      const now = new Date();
      const hoursDifference = (scheduleDate.getTime() - now.getTime()) / (1000 * 60 * 60);
      return hoursDifference < -1;
    },

    generateAppointmentLink(vetPin: string): string {
      return `${this.appointmentLink}${vetPin}?lang=${this.$i18n.locale}`;
    }
  }
});
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
</style>
